(() => {
  const DISCOUNTS_BY_PRODUCT = {
    'sublime-renovation': {
      2: 'ORIBIO-2-SUBLIME-10',
      3: 'ORIBIO-3-SUBLIME-15',
    },
    'maximum-elixir': {
      2: 'ORIBIO-2-MAXIMUM-10',
      3: 'ORIBIO-3-MAXIMUM-15',
    },
    'divine-miracle': {
      2: 'ORIBIO-2-DIVINE-10',
      3: 'ORIBIO-3-DIVINE-15',
    },
    'lino-active-gel': {
      2: 'ORIBIO-2-LINO-10',
      3: 'ORIBIO-3-LINO-15',
    },
    'glow-resistant-spray-sellante': {
      2: 'GLOW EXTRA',
      3: 'GLOW COMBO',
    },
  };

  const MANAGED_CODES = new Set(
    Object.values(DISCOUNTS_BY_PRODUCT).flatMap((discounts) => Object.values(discounts))
  );

  class OribioVolumeDiscounts {
    constructor() {
      this.queue = Promise.resolve();
      this.onCartUpdate = this.onCartUpdate.bind(this);
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);

      const syncInitialCart = () => {
        this.enqueueSync().then((changed) => {
          if (changed) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oribio-volume-discounts' });
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncInitialCart, { once: true });
      } else {
        syncInitialCart();
      }
    }

    onCartUpdate(event) {
      if (event.source === 'oribio-volume-discounts') return;
      return this.enqueueSync(event.cartData);
    }

    enqueueSync(cartData) {
      const sync = this.queue.then(() => this.sync(cartData));
      this.queue = sync.catch(() => false);
      return sync.catch((error) => {
        this.showError(error);
        return false;
      });
    }

    async sync(cartData) {
      const cart = await this.fetchCart();
      const desiredManagedCodes = this.getDesiredManagedCodes(cart.items);
      const appliedCodes = this.getAppliedCodes(cart);
      const manualCodes = appliedCodes.filter((code) => !MANAGED_CODES.has(code));
      const desiredCodes = [...manualCodes, ...desiredManagedCodes];

      if (this.haveSameCodes(appliedCodes, desiredCodes)) return false;

      const sectionIds = Object.keys(cartData?.sections || {});
      const body = {
        discount: desiredCodes.join(','),
      };

      if (sectionIds.length > 0) {
        body.sections = sectionIds;
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });
      const updatedCart = await response.json();

      if (!response.ok || updatedCart.errors) {
        throw new Error(updatedCart.description || updatedCart.message || updatedCart.errors || 'Discount update failed');
      }

      const missingCodes = desiredManagedCodes.filter((code) => !this.getAppliedCodes(updatedCart).includes(code));
      if (missingCodes.length > 0) {
        throw new Error(`Shopify did not apply the expected volume discount: ${missingCodes.join(', ')}`);
      }

      if (cartData && updatedCart.sections) {
        cartData.sections = updatedCart.sections;
        cartData.item_count = updatedCart.item_count;
        cartData.items = updatedCart.items;
        cartData.total_price = updatedCart.total_price;
        cartData.total_discount = updatedCart.total_discount;
      }

      return true;
    }

    async fetchCart() {
      const response = await fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      const cart = await response.json();

      if (!response.ok || cart.errors) {
        throw new Error(cart.description || cart.message || cart.errors || 'Cart request failed');
      }

      return cart;
    }

    getDesiredManagedCodes(items) {
      const quantities = items.reduce((totals, item) => {
        if (!DISCOUNTS_BY_PRODUCT[item.handle]) return totals;
        totals[item.handle] = (totals[item.handle] || 0) + item.quantity;
        return totals;
      }, {});

      return Object.entries(quantities).flatMap(([handle, quantity]) => {
        if (quantity >= 3) return [DISCOUNTS_BY_PRODUCT[handle][3]];
        if (quantity >= 2) return [DISCOUNTS_BY_PRODUCT[handle][2]];
        return [];
      });
    }

    getAppliedCodes(cart) {
      const codes = new Set();

      cart.discount_codes?.forEach(({ code }) => code && codes.add(code));
      cart.cart_level_discount_applications?.forEach((application) => {
        if (application.type === 'discount_code' && application.title) codes.add(application.title);
      });
      cart.items?.forEach((item) => {
        item.line_level_discount_allocations?.forEach(({ discount_application: application }) => {
          if (application?.type === 'discount_code' && application.title) codes.add(application.title);
        });
      });

      return [...codes];
    }

    haveSameCodes(currentCodes, desiredCodes) {
      if (currentCodes.length !== desiredCodes.length) return false;
      const desired = new Set(desiredCodes);
      return currentCodes.every((code) => desired.has(code));
    }

    showError(error) {
      console.error('[ORIBIO volume discounts]', error);
      const errorContainer = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errorContainer) {
        errorContainer.textContent = 'No pudimos aplicar el descuento por volumen. Inténtalo de nuevo.';
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    new OribioVolumeDiscounts();
  }
})();
